export default class extends Controller {
  static targets = ["body", "buttonContainer"];

  connect() {
    App.Helpers.ajaxRequest({url: this.popoverURL, successHandler: this.setPopoverContent.bind(this)});
  }

  setPopoverContent({list, button}) {
    this.body = list;
    this.button = button;
  }

  close() {
    App.closePopovers();
  }

  //
  // GETTERS AND SETTERS
  //

  get popoverURL() {
    return this.data.get("popover-url");
  }

  set body(html) {
    this.bodyTarget.innerHTML = html;
  }

  set button(html) {
    this.buttonContainerTarget.innerHTML = html;
  }
};



// WEBPACK FOOTER //
// ./app/components/notifications/assets/javascript/notifications-popover-template-controller.js